import { render, staticRenderFns } from "./LoginExpositor.vue?vue&type=template&id=c8ffb176"
import script from "./LoginExpositor.vue?vue&type=script&lang=js"
export * from "./LoginExpositor.vue?vue&type=script&lang=js"
import style0 from "./LoginExpositor.vue?vue&type=style&index=0&id=c8ffb176&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports